import script from "./IndexPart4.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPart4.vue?vue&type=script&setup=true&lang=js"

import "./IndexPart4.vue?vue&type=style&index=0&id=f0372b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0372b22"]])

export default __exports__